import React from 'react';
import { Image } from "@project-stories/elements/Image/Image";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function Carousel({settings, section, columns}) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || "1024px");
  
  const gapBetweenBlocksX = isMobile
    ? settings.section.gap_mobile
    : settings.section.gap;
  const gapBetweenBlocksY = isMobile
    ? settings.section.gap_y_mobile
    : settings.section.gap_y;
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-8 lg:gap-11 w-full lg:w-96 pr-3">
        <div>
          {section.tagline && <div className="b_a1 pb-2">{section.tagline}</div>}
          <div className={`${isMobile ? section.title_font_type_mobile : section.title_font_type}`}>
            {section.title}
          </div>
        </div>
        <div className={`${isMobile ? section.subtitle_style_mobile : section.subtitle_style}`}>
          {section.subtitle}
        </div>
      </div>
      <div className="result-carousel carousel flickity-dot-relative"
        {...({
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(${section.show_indicators}, ${section.show_navbuttons}, ${section.fade_edgeitems}, false, 0, 'service-results-carousel', true, ${section.use_freescroll}) })`,
          "x-ref": "carousel",
        })}
      >
        {columns.map((column, index) => (
          <div key={index}
            style={{
              marginTop: `${gapBetweenBlocksY / 2}px`,
              marginBottom: `${gapBetweenBlocksY / 2}px`,
              marginLeft: `${gapBetweenBlocksX / 2}px`,
              marginRight: `${gapBetweenBlocksX / 2}px`,
              maxWidth: `${isMobile ? '300px' : '100%'}`,
              display: 'grid',
              width: '100%',
              minHeight: '300px',
            }}
          >
            <div className="border-arc-prisma backdrop-blur px-6 py-12 border rounded">
              <div className="flex items-center justify-between">
                <span className="d1">{column.settings.title}</span>
                <div className="border-arc-prisma-full relative w-14 h-14 flex items-center justify-center">
                  <div className="w-14 h-14">
                    <Image classes="w-full h-full" imageUrl={column.settings.image_icon} alt={column.settings.title} height="60" width="60" />
                  </div>
                </div>
              </div>
              <div className={`${isMobile ? 'b_regular_light' : 'b_large_light'} pt-1`}>
                {column.settings.subtitle}
              </div>
              <div className="b_tiny_light pt-6">
                {column.settings.content}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}